<template>
    <b-row>
        <b-col cols="12">
            <filter-component/>
            <b-card v-if="dashboard_metrics.length !== 0">
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <b-tabs v-model="tabIndex">
                        <b-tab title="CM">
                            <div class="dashboard-metrics table-responsive">
                                <table class="table table-striped table-bordered table-sm" width="100%" cellspacing="0">
                                    <thead>
                                    <tr>
                                        <th rowspan="2" class="sticky text-center" style="background: linear-gradient(to bottom, rgba(220, 211, 228, 1), rgba(255, 255, 255, 0));"><img :src="imgLogo" width="200" class="mt-1" height="50" alt="Descrição da imagem"></th>
                                        <th v-if="showOnlyPlanned" class="ejecutado-title text-white" colspan="6">Ejecutado</th>
                                        <th v-if="showPlanned" class="en-curso-title text-white planned" colspan="6">En curso - En plazo</th>
                                        <th v-if="showOnlyPlanned" class="vencido-title text-white" colspan="6">En curso - Fuera de plazo</th>

                                        <th v-if="showOnlyPlanned" rowspan="3" colspan="2" style="vertical-align: middle;" class="totales-general text-white">TOTALES</th>
                                    </tr>
                                    <tr>
                                        <th v-if="showOnlyPlanned" class="ejecutado-subs-title" colspan="2">EN PLAZO</th>
                                        <th v-if="showOnlyPlanned" class="ejecutado-subs-title" colspan="2">Fuera de PLAZO</th>
                                        <th v-if="showOnlyPlanned" class="ejecutado-totales" colspan="1">Nº TOTAL</th>
                                        <th v-if="showOnlyPlanned" class="ejecutado-totales" colspan="1">% TOTAL</th>
                                        <th v-if="showPlanned" class="en-curso-subs-title planned" colspan="4">EN PLAZO
                                        </th>
                                        <th v-if="showPlanned" class="en-curso-totales" colspan="1">Nº TOTAL EN PLAZO</th>
                                        <th v-if="showPlanned" class="en-curso-totales" colspan="1">% TOTAL EN PLAZO
                                        </th>
                                        <th v-if="showOnlyPlanned" class="vencido-subs-title" colspan="4">FUERA DE PLAZO</th>
                                        <th v-if="showOnlyPlanned" class="vencido-totales" colspan="1">Nº TOTAL FUERA DE PLAZO</th>
                                        <th v-if="showOnlyPlanned" class="vencido-totales" colspan="1">% TOTAL FUERA DE PLAZO</th>
                                    </tr>
                                    <tr>
                                        <th colspan="1" class="sticky"/>
                                        <th v-if="showOnlyPlanned" colspan="2"></th>
                                        <th v-if="showOnlyPlanned" colspan="2"></th>
                                        <th v-if="showOnlyPlanned" class="ejecutado-totales" colspan="2" rowspan="1"></th>
                                        <th v-if="showPlanned" colspan="2" class="planned">Planificada</th>
                                        <th v-if="showPlanned" colspan="2" class="planned">Prevision 3 meses</th>
<!--                                        <th v-if="showPlanned" colspan="2" class="planned">Pendiente de validación</th>-->
                                        <th v-if="showPlanned" colspan="2" class="en-curso-totales planned"></th>
                                        <th v-if="showOnlyPlanned" colspan="2">Entre 0 y 3 meses</th>
                                        <th v-if="showOnlyPlanned" colspan="2">Más de 3 meses</th>
                                        <th v-if="showOnlyPlanned" class="vencido-totales" colspan="2"></th>
                                    </tr>
                                    <tr>
                                        <th colspan="1" class="sticky"/>
                                        <th v-if="showOnlyPlanned" colspan="1">Nº</th>
                                        <th v-if="showOnlyPlanned" colspan="1">%</th>
                                        <th v-if="showOnlyPlanned" colspan="1">Nº</th>
                                        <th v-if="showOnlyPlanned" colspan="1">%</th>
                                        <th v-if="showOnlyPlanned" class="ejecutado-totales" colspan="2"></th>
                                        <th v-if="showPlanned" colspan="1" class="planned">Nº</th>
                                        <th v-if="showPlanned" colspan="1" class="planned">%</th>
                                        <th v-if="showPlanned" colspan="1" class="planned">Nº</th>
                                        <th v-if="showPlanned" colspan="1" class="planned">%</th>
<!--                                        <th v-if="showPlanned" colspan="1" class="planned">Num.</th>
                                        <th v-if="showPlanned" colspan="1" class="planned">Porc</th>-->
                                        <th v-if="showPlanned" colspan="2" class="en-curso-totales planned"></th>
                                        <th v-if="showOnlyPlanned" colspan="1">Nº</th>
                                        <th v-if="showOnlyPlanned" colspan="1">%</th>
                                        <th v-if="showOnlyPlanned" colspan="1">Nº</th>
                                        <th v-if="showOnlyPlanned" colspan="1">%</th>
                                        <th v-if="showOnlyPlanned" class="vencido-totales" colspan="1"></th>
                                        <th v-if="showOnlyPlanned" class="vencido-totales" colspan="1"></th>
                                        <th v-if="showOnlyPlanned" class="totales-general" colspan="1">Nº TOTAL</th>
                                        <th v-if="showOnlyPlanned" class="totales-general" colspan="1">% TOTAL
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="dashboard_metrics.length !== 0">
                                    <template v-for="(statistics, classification) in dashboard_metrics">
                                        <tr :key="Math.random()" >
                                            <td class="sticky-col" @click="toggleRowsResume(classification)">
                                                <feather-icon
                                                    :id="`record-row-plus-circle-icon`"
                                                    :icon="expandedClassifications[classification] ? 'MinusSquareIcon' : 'PlusSquareIcon'"
                                                    size="16"
                                                    class="cursor-pointer"
                                                />&nbsp;
                                                <b>{{ classification }}</b>
                                            </td>
                                            <td v-if="showOnlyPlanned" @click="toggleRowsResume(classification)">
                                                <b>
                                                      <span style="cursor: pointer; text-decoration: underline;"
                                                            @click="seeInstallations('executed_on_date', classification, dashboard_metrics[classification]['executed_on_date']['installations'])">
                                                        {{
                                                              dashboard_metrics[classification]['total_executed_doc_on_date']
                                                          }}
                                                        </span>
                                                </b>
                                            </td>
                                            <td v-if="showOnlyPlanned">
                                                {{
                                                    dashboard_metrics[classification]['percentage_executed_class_on_date']
                                                }}%
                                            </td>
                                            <td v-if="showOnlyPlanned">
                                                <b>
                                                    <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('executed_out_of_date', classification, dashboard_metrics[classification]['executed_out_of_date']['installations'])">
                                                        {{
                                                            dashboard_metrics[classification]['total_executed_doc_out_of_date']
                                                        }}
                                                    </span>
                                                </b>

                                            </td>
                                            <td v-if="showOnlyPlanned">
                                                {{
                                                    dashboard_metrics[classification]['percentage_executed_class_out_of_date']
                                                }}%
                                            </td>
                                            <td v-if="showOnlyPlanned" class="ejecutado-totales">
                                                <b>
                                                    <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('', classification, dashboard_metrics[classification]['executed_on_date']['installations'].concat(dashboard_metrics[classification]['executed_out_of_date']['installations']))">
                                                        {{
                                                            dashboard_metrics[classification]['total_executed_class']
                                                        }}
                                                    </span>
                                                </b>
                                            </td>
                                            <td v-if="showOnlyPlanned" class="ejecutado-totales">
                                                {{ dashboard_metrics[classification]['percentage_executed_class'] }}%
                                            </td>
                                            <td v-if="showPlanned" class="planned">
                                                <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', classification, dashboard_metrics[classification]['planned']['installations'])">
                                                        {{
                                                        dashboard_metrics[classification]['total_doc_planned']
                                                    }}
                                                    </span>
                                                </b>
                                            </td>
                                            <td v-if="showPlanned" class="planned">
                                                {{ dashboard_metrics[classification]['percentage_planned_class'] }}%
                                            </td>
                                            <td v-if="showPlanned" class="planned">
                                                <b>
                                                      <span style="cursor: pointer; text-decoration: underline;"
                                                            @click="seeInstallations('', classification, dashboard_metrics[classification]['planned_less_3_months']['installations'])">
                                                        {{
                                                              dashboard_metrics[classification]['total_doc_planned_3_months']
                                                          }}
                                                    </span>
                                                </b>

                                            </td>
                                            <td v-if="showPlanned" class="planned">
                                                {{
                                                    dashboard_metrics[classification]['percentage_planned_3_months_class']
                                                }}%
                                            </td>
                                            <td v-if="showPlanned" class="planned en-curso-totales">
                                                <b>
                                                    <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('', classification, dashboard_metrics[classification]['planned']['installations'])">
                                                        {{
                                                            dashboard_metrics[classification]['total_planned_class']
                                                        }}
                                                </span>
                                                </b>

                                            </td>
                                            <td v-if="showPlanned" class="planned en-curso-totales">
                                                {{
                                                    dashboard_metrics[classification]['percentage_total_planned_class']
                                                }}%
                                            </td>
                                            <td v-if="showOnlyPlanned">
                                                <b>
                                                    <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('', classification, dashboard_metrics[classification]['not_executed_less_3_months']['installations'])">
                                                        {{
                                                            dashboard_metrics[classification]['total_doc_out_of_date_less_3_months']
                                                        }}
                                                    </span>
                                                </b>
                                            </td>
                                            <td v-if="showOnlyPlanned">
                                                {{
                                                    dashboard_metrics[classification]['percentage_out_of_date_class_less_3_months']
                                                }}%
                                            </td>
                                            <td v-if="showOnlyPlanned">
                                                <b>
                                                    <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('', classification, dashboard_metrics[classification]['not_executed_more_3_months']['installations'])">
                                                        {{
                                                            dashboard_metrics[classification]['total_doc_out_of_date_more_3_months']
                                                        }}
                                                    </span>
                                                </b>
                                            </td>
                                            <td v-if="showOnlyPlanned">
                                                {{
                                                    dashboard_metrics[classification]['percentage_out_of_date_class_more_3_months']
                                                }}%
                                            </td>
                                            <td v-if="showOnlyPlanned" class="vencido-totales">
                                                <b>
                                                    <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('', classification, (dashboard_metrics[classification]['not_executed_less_3_months']['installations'].concat(dashboard_metrics[classification]['not_executed_more_3_months']['installations'])))">
                                                        {{
                                                            dashboard_metrics[classification]['total_out_of_date_class']
                                                        }}
                                                </span>
                                                </b>
                                            </td>
                                            <td v-if="showOnlyPlanned" class="vencido-totales">
                                                {{
                                                    dashboard_metrics[classification]['percentage_out_of_date_class']
                                                }}%
                                            </td>
                                            <td v-if="showOnlyPlanned" class="totales-general">
                                                <b>
                                                    <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('', classification, (dashboard_metrics[classification]['executed_on_date']['installations'].concat(dashboard_metrics[classification]['executed_out_of_date']['installations']).concat(dashboard_metrics[classification]['not_executed_more_3_months']['installations']).concat(dashboard_metrics[classification]['not_executed_less_3_months']['installations']).concat(dashboard_metrics[classification]['planned']['installations'])))">
                                                        {{
                                                            dashboard_metrics[classification]['total_class_row']
                                                        }}
                                                </span>
                                                </b>
                                            </td>
                                            <td v-if="showOnlyPlanned" class="totales-general">
                                                <b>
                                                    100%
                                                </b>
                                            </td>

                                        </tr>

                                        <detail-row v-for="(data, docName) in statistics"
                                                    v-if="expandedClassifications[classification] && !arrayOfDocNames.includes(docName)" :data="data"
                                                    :classification="classification"
                                                    :docname="docName" :key="Math.random()"/>

                                    </template>
                                    <tr :key="Math.random()">
                                        <td><b>TOTAL GENERAL</b></td>
                                        <td v-if="showOnlyPlanned">
                                            <b>
                                                    <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('', 'Ejecutados', totals.total_general_executed_on_date.installations)">
                                                     {{totals.total_general_executed_on_date.total}}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showOnlyPlanned">
                                            {{totals.percentage_general_executed_on_date}}%
                                        </td>
                                        <td v-if="showOnlyPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', 'Ejecutados - Fuera de plazo', totals.total_general_executed_out_of_date.installations)">
                                                    {{totals.total_general_executed_out_of_date.total}}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showOnlyPlanned">
                                            {{totals.percentage_general_executed_out_of_date}}%
                                        </td>
                                        <td v-if="showOnlyPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', 'En curso - Ejecutados Total', totals.total_general_executed.installations)">
                                                     {{ totals.total_general_executed.total }}
                                                </span>
                                            </b>
                                        <td v-if="showOnlyPlanned" >{{ totals.percentage_executed_total }}%</td>
                                        <td v-if="showPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', 'En Curso - En Plazo - Planificada', totals.total_general_planned_planned.installations)">
                                                     {{ totals.total_general_planned_planned.total }}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showPlanned"> {{ totals.percentage_general_planned }}%</td>
                                        <td v-if="showPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', 'En Curso - En Plazo - Planificada Menos de 2 meses', totals.total_general_planned_less_3_months.installations)">
                                                     {{ totals.total_general_planned_less_3_months.total }}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showPlanned">{{ totals.percentage_general_planned_less_3_months }}%</td>
                                        <td v-if="showPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', 'Planificada - Total', totals.total_general_planned_planned.installations)">
                                                     {{totals.total_general_planned.total}}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showPlanned">{{ totals.percentage_planned_total }}%</td>
                                        <td v-if="showOnlyPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                          @click="seeInstallations('', 'En curso - Fuera de plazo - 1 y 3 meses', totals.total_general_not_executed_less_3_months.installations)">
                                                     {{totals.total_general_not_executed_less_3_months.total}}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showOnlyPlanned">{{ totals.percentage_general_out_of_date_less_3_months }}%</td>
                                        <td v-if="showOnlyPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', 'En curso - Fuera de plazo - más de 3 meses', totals.total_general_not_executed_more_3_months.installations)">
                                                     {{totals.total_general_not_executed_more_3_months.total}}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showOnlyPlanned">{{ totals.percentage_general_out_of_date_more_3_months }}%</td>
                                        <td v-if="showOnlyPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', 'En curso - Fuera de plazo - Total', totals.total_general_out_of_date.installations)">
                                                     {{totals.total_general_out_of_date.total}}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showOnlyPlanned">{{ totals.percentage_out_of_date_total }}%</td>
                                        <td v-if="showOnlyPlanned">
                                            <b>
                                                <span style="cursor: pointer; text-decoration: underline;"
                                                      @click="seeInstallations('', 'Total', totals.total_general.installations)">
                                                     {{totals.total_general.total}}
                                                </span>
                                            </b>
                                        </td>
                                        <td v-if="showOnlyPlanned" ><b>100%</b></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-tab>
                        <b-tab :title="contentName">
                            <installations-details-view/>
                        </b-tab>
                    </b-tabs>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {BCard, BCol, BOverlay, BRow, BTab, BTabs} from 'bootstrap-vue'
import {mapState} from "vuex"
import helpers from "@/resources/helpers/helpers"
import {createHelpers} from "vuex-map-fields"

import filterComponent from "@/views/gei/dashboard_metrics/list/components/filterComponent.vue"
import detailRow from "@/views/gei/dashboard_metrics/list/components/detailRow.vue"
import installationsDetailsView from "@/views/gei/dashboard_metrics/list/components/installationsDetailsView"

const {mapFields} = createHelpers({
    getterType: 'dashboardMetrics/getField',
    mutationType: 'dashboardMetrics/updateField',
})

export default {
    name: "ListView",
    components: {
        BTabs,
        BTab,
        BRow,
        BCol,
        BCard,
        BOverlay,

        detailRow,
        filterComponent,
        installationsDetailsView
    },
    data() {
        return {
            showRowsResume: false,
            showRowsInstallations: false,
            expandedRows: {},
            activeGroups: [],

            data: [],
            expandedClassifications: {},
            currentYear: null,

            arrayOfDocNames: [
                'executed_on_date', 'executed_out_of_date','not_executed_more_3_months',
                'not_executed_more_3_months','not_executed_less_3_months', 'planned',
                'planned_validation','planned_less_3_months', 'percentage_planned_validation_class',
                'total_executed_doc_on_date', 'total_executed_doc_out_of_date',
                'total_doc_out_of_date_less_3_months', 'total_doc_out_of_date_more_3_months',
                'total_doc_planned_3_months', 'total_doc_planned',
                'total_doc_planned_validation', 'total_executed_class',
                'total_planned_class', 'total_out_of_date_class',
                'total_class_row', 'percentage_out_of_date_class',
                'percentage_executed_class', 'percentage_total_planned_class',
                'percentage_executed_class_out_of_date', 'percentage_executed_class_on_date',
                'percentage_out_of_date_class_less_3_months', 'percentage_out_of_date_class_more_3_months',
                'percentage_planned_class', 'percentage_planned_3_months_class',
                'percentage_planned_validation_class'],

            helpers
        }
    },
    computed: {
        showPlanned: function () {
            const currentYear = new Date().getFullYear()

            return this.filter.year >= currentYear
        },
        showOnlyPlanned: function () {
            const currentYear = new Date().getFullYear()

            return this.filter.year !== (currentYear+1)
        },
        ...mapState('dashboardMetrics', ['dashboard_metrics']),
        ...mapFields({
            dashboard_metrics: 'dashboard_metrics',
            totals: 'totals',
            installation_list: 'installation_list',
            tabIndex: 'tabIndex',
            filter: 'filter',
            showLoading: 'showLoading',
            contentName: 'contentName'
        }),
        imgLogo() {
            return require('@/assets/images/logo/logo-endesa-x.png')
        },
    },
    created() {
        // this.installationsByClassification()
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        toggleRowsResume(classification) {
            this.$set(this.expandedClassifications, classification, !this.expandedClassifications[classification])
        },
        seeInstallations(content, classification, installationsList = null) {
            this.tabIndex++
            this.installation_list = []
            this.contentName = this.setTableTitle(content)

        
            const installationIds = Object.keys(installationsList).map(installationKey => {
                return installationsList[installationKey].id
            })

            const installationIdsNew = []

            for (const key in installationsList) {
                if (installationsList.hasOwnProperty(key)) {

                    const installations = installationsList[key]
                    

                    for (const keyInst in installations) {
                        if (installations.hasOwnProperty(keyInst)) {
                            if (installations[keyInst].id) {
                                installationIdsNew.push(installations[keyInst].id)
                            }
                        }

                    }

                }
            }

            this.showLoading = true
            try {
                this.$store.dispatch('childrenInstallation/getChildInstallationsByIds', {
                    relations: ['typology', 'masterInstallation.company', 'masterInstallation.responsible',
                        'providerContractEE', 'documentOca.inspection', 'documentOca.ocaType'],
                    ids: installationIdsNew
                })
                .then(response => {
                    this.showLoading = false

                    if (response) {
                        let responseData = []
                        for (const installationKey in installationsList) {

                            if (installationsList.hasOwnProperty(installationKey)) {

                                const installations = installationsList[installationKey]
                                for (const keyInst in installations) {
                                  
                                    if (installations.hasOwnProperty(keyInst)) {
                                        const installation = installations[keyInst]
                                        responseData = response.find(item => item.id === installation.id)
                                        if (responseData) {
                                            const copiedResponse = {...responseData}
                                            copiedResponse.effective_date = installation.effective_date
                                            copiedResponse.expected_date = installation.expected_date
                                            copiedResponse.classification = classification
                                            copiedResponse.document_name = installation.document_name
                                            this.installation_list.push(copiedResponse)
                                        }
                                    }

                                }

                            }

                        }
                    } else {
                        console.error('Erro ao obter os dados das instalações:', response)
                    }
                })
                .catch(error => {
                    this.showLoading = false
                    console.error('Error al obtener instalaciones:', error)
                })
            } catch (error) {
                console.error('Error al obtener instalaciones', error)
                throw error
            }
        },
        setTableTitle(content) {
            if (content == '') {
                return 'Listado de instalaciones'
            }

            if (content == 'executed_on_date') {
                return 'Listado de instalaciones - Ejecutadas en plazo'
            }
            if (content == 'executed_out_of_date') {
                return 'Listado de instalaciones - Ejecutadas fuera de plazo'
            }
            if (content == 'planned') {
                return 'Listado de instalaciones - Planificada'
            }
            if (content == 'planned_less_3_months') {
                return 'Listado de instalaciones - Planificada - menos de dos meses'
            }
            if (content == 'planned_validation') {
                return 'Listado de instalaciones - Planificada - pendiente de validación'
            }
            if (content == 'not_executed_less_3_months') {
                return 'Listado de instalaciones - Fuera de plazo - menos de 3 meses'
            }
            if (content == 'not_executed_more_3_months') {
                return 'Listado de instalaciones - Fuera de plazo - mas de 3 meses'
            }
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

[dir] .dashboard-metrics {
    font-size: 12px;
}

.bg-light-grey {
    background-color: #f5f5f5;
    color: black;
}

.wrapper {
    position: relative;
    overflow: auto;
    border: 1px solid black;
    white-space: nowrap;
}

.table .sticky, .table td:first-child {
    position: sticky;
    border-top: 1px solid #ebe9f1;
    left: 0;
    background-color: #fafafc;
}

.table th {
    text-align: center;
}
/* Fundo gradiente para a classe .ejecutado-title */
.table .ejecutado-title {
    background-image: linear-gradient(to right, rgba(70, 30, 126, 1), transparent);
}

/* Fundo para a classe .ejecutado-subs-title */
.table .ejecutado-subs-title {
    background-color: rgba(177, 160, 199, 0.7) !important; /* Ajuste do valor alfa */
}

/* Fundo para a classe .ejecutado-totales */
.table .ejecutado-totales {
    background-color: rgba(216, 224, 248, 1) !important;
}

/* Fundo gradiente para a classe .en-curso-title */
.table .en-curso-title {
    background-image: linear-gradient(to right, rgba(0, 126, 196, 0.7), transparent);
}
.table .en-curso-subs-title {
    background-color: rgba(141, 180, 226, 1) !important;
}
.table .en-curso-totales {
    background-color: rgba(181, 206, 237, 1) !important;
}
/* Vencidos */
.table .vencido-title {
    background-image: linear-gradient(to right, rgba(235, 155, 90, 1), transparent);
}

.table .vencido-subs-title {
    background-color: rgba(250, 191, 143, 1) !important;
}

.table .vencido-totales {
    background-color: rgba(253, 230, 211, 1) !important;
}
.table .totales-general {
    background-color: rgba(177, 192, 241, 1) !important;
}
</style>